export default __webpack_public_path__ + "static/media/Couv_Guide_RH.0e5a00da.jpg";